import { render, staticRenderFns } from "./SiswaDashboard.vue?vue&type=template&id=e2a138e6&scoped=true"
import script from "./SiswaDashboard.vue?vue&type=script&lang=js"
export * from "./SiswaDashboard.vue?vue&type=script&lang=js"
import style0 from "./SiswaDashboard.vue?vue&type=style&index=0&id=e2a138e6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e2a138e6",
  null
  
)

export default component.exports